import {Pipe, PipeTransform} from '@angular/core';
import {BroadcastNotificationScopeTypes} from "../enum/BroadcastNotificationScopeTypes";

@Pipe({
  name: 'broadcastNotificationScope'
})
export class BroadcastNotificationScopePipe implements PipeTransform {
  public transform(typeP: BroadcastNotificationScopeTypes): string {
    if (typeP) {
      switch (typeP) {
        case BroadcastNotificationScopeTypes.System: return 'System';
        case BroadcastNotificationScopeTypes.Game: return 'Game';
      }
    }
    return 'Unknown Broadcast Notification Scope Type';
  }
}
